import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

// awards-service sits behind the /awards-service-api/ gateway prefix, which the
// Istio VirtualService rewrites to /. pageSize is fixed server-side at 15 and
// is not a parameter.
export const getCycles = async (page = 1) => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get('/awards-service-api/admin/cycles', {
    headers,
    params: { page },
  });

  return response.data;
};
